import { render } from "./SmIconEditComponent.vue?vue&type=template&id=9d014c78"
import script from "./SmIconEditComponent.vue?vue&type=script&lang=js"
export * from "./SmIconEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/SmIconEditComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d014c78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d014c78', __exports__)) {
    api.reload('9d014c78', __exports__)
  }
  
  module.hot.accept("./SmIconEditComponent.vue?vue&type=template&id=9d014c78", () => {
    api.rerender('9d014c78', render)
  })

}


export default __exports__